import { render, staticRenderFns } from "./HeaderImagesPreview.vue?vue&type=template&id=12973cb1&scoped=true&"
import script from "./HeaderImagesPreview.vue?vue&type=script&lang=js&"
export * from "./HeaderImagesPreview.vue?vue&type=script&lang=js&"
import style0 from "./HeaderImagesPreview.vue?vue&type=style&index=0&id=12973cb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12973cb1",
  null
  
)

export default component.exports